import { useQuery } from '@tanstack/react-query'
import type { Season } from '../types'

export const useSeasons = () => {
    return useQuery<Season[]>({
        queryKey: ['leaderboard', 'seasons'],
        queryFn: async () => {
            const res = await fetch('/api/leaderboard/seasons/')
            return res.json()
        },
        retry: false,
    })
}
